// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1nCS6","checkboxCol":"Table_checkboxCol__1nvdB","emailCol":"Table_emailCol__1NnEX","actionCol":"Table_actionCol__3lvfp"};